import '@popperjs/core';
import jquery from 'jquery';

window.jQuery = jquery;
window.$ = jquery;
import {Modal} from 'bootstrap';
import 'glightbox';
import 'isotope-layout';
// core version + navigation, pagination modules:
import Swiper, {Navigation, Pagination} from 'swiper';
import 'aos';
import 'aos-animations/dist/animations.min';
import '@srexi/purecounterjs';
import './theme/main.js';

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },
    cache: true
});

$.fn.isVisible = function () {
    let elementTop = $(this).offset().top;
    let elementBottom = elementTop + $(this).outerHeight();
    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};

let utility = {
    gtag: function () {
        dataLayer.push(arguments);
    },
    scroll: function (e) {
        $('html').animate({
            scrollTop: (e.offset().top - 100)
        }, "slow");
    },
    viewable: function (e) {
        let docViewTop = $(window).scrollTop();
        let docViewBottom = docViewTop + $(window).height();
        let elemTop = $(e).offset().top;
        let elemBottom = elemTop + $(e).height();
        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    },
    modal: {
        defaults: {
            closeable: false,
            icon: 'fa fa-info',
            title: {
                text: 'Info',
                color: 'text-white'
            },
            size: 'modal-lg',
            state: 'bg-info',
            resize: false,
            class: null,
            border: null,
            submitButtonClass: 'btn-success',
            cancelButtonClass: 'btn-secondary'
        },
        loading: function (selector) {
            selector = (selector === undefined ? $('#ModalWindowBody') : selector);
            let HTML = '<div class="text-center" style="width: 100%; margin: auto; padding: 15%;"><i class="fa fa-spinner fa-pulse fa-fw fa-5x text-primary"></i><div style="font-size: 36px;">LOADING...</div></div>';
            selector.html(HTML);
        },
        open: function (options) {
            let Deferred = new $.Deferred();
            options = {
                closeable: (options.closeable !== undefined ? options.closeable : utility.modal.defaults.closeable),
                icon: (options.icon !== undefined ? options.icon : utility.modal.defaults.icon),
                title: {
                    text: (options.title.text !== undefined ? options.title.text : utility.modal.defaults.title.text),
                    color: (options.title.color !== undefined ? options.title.color : utility.modal.defaults.title.color),
                },
                size: (options.size !== undefined ? options.size : utility.modal.defaults.size),
                state: (options.state !== undefined ? options.state : utility.modal.defaults.state),
                resize: (options.resize !== undefined ? options.resize : utility.modal.defaults.resize),
                class: (options.class !== undefined ? options.class : utility.modal.defaults.class),
                border: (options.border !== undefined ? options.border : utility.modal.defaults.border),
                submitButtonClass: (options.submitButtonClass !== undefined ? options.submitButtonClass : utility.modal.defaults.submitButtonClass),
                cancelButtonClass: (options.cancelButtonClass !== undefined ? options.cancelButtonClass : utility.modal.defaults.cancelButtonClass),
            };
            $('#ModalWindowWrapper').load('/actions/modal/modal/open', {}, function () {
                let $ModalWindowBody = $('#ModalWindowBody');
                $('#ModalWindowDialog').addClass(options.size);
                $('#ModalWindowIcon').addClass(options.icon).addClass(options.title.color);
                $('#ModalWindowTitle').html(options.title.text).addClass(options.title.color);
                if (options.closeable === false) {
                    $('#ModalWindowCloseButton').hide();
                }
                $('#ModalWindowHeader').addClass(options.state);
                $('#ModalWindowHeader, #ModalWindowBody, #ModalWindowFooter').addClass(options.class);
                $('#ModalWindowHeader, #ModalWindowFooter').addClass(options.border);
                $('#ModalWindowSaveButton').addClass(options.submitButtonClass);
                $('#ModalWindowCancelButton').addClass(options.cancelButtonClass);
                let ModalWindow = document.getElementById('ModalWindow');
                let $Modal = new Modal(ModalWindow, {
                    backdrop: 'static',
                    keyboard: false
                });
                $Modal.show();
                ModalWindow.addEventListener('hidden.bs.modal', function () {
                    $(this).remove();
                });
                if (options.resize === true) {
                    $ModalWindowBody.on('DOMSubtreeModified', function () {
                        utility.modal.resize($(this));
                    });
                }
                Deferred.resolve($ModalWindowBody);
            });
            return Deferred.promise();
        },
        resize: function ($Element) {
            let ModalHeaderFooterHeight = $('#ModalWindowHeader').outerHeight() + $('#ModalWindowFooter').outerHeight();
            let y = Math.round(($(window).innerHeight() - ModalHeaderFooterHeight) / 1.4);
            $Element.height(y);
            return false;
        },
        scroll: function (selector, offset) {
            let Deferred = new $.Deferred();
            offset = (offset === undefined ? ($('#ModalWindowHeader').height() + 60) : 0);
            $('#ModalWindowBody').animate({
                scrollTop: (selector.offset().top - offset) + $(this).scrollTop()
            }, "slow", function () {
                Deferred.resolve(false);
            });
            return Deferred.promise();
        },
        video: function (selector) {
            let Deferred = new $.Deferred();
            let options = {
                icon: 'fa fa-video',
                title: {
                    text: $(selector).attr('data-title'),
                    color: 'text-white'
                },
                state: 'bg-danger',
                size: 'modal-lg'
            };
            $.when(utility.modal.open(options)).done(function () {
                $('#ModalWindowBody').load('/modal/video', function (HTML) {
                    $.when($('#ModalWindowBody').html(HTML)).done(function () {
                        $('#ModalVideoSource').attr('src', $(selector).attr('data-target'));
                        Deferred.resolve(false);
                    });
                });
                $('#ModalWindowSaveButton').remove();
                return Deferred.promise();
            });
        },
        content: function (selector) {
            let Deferred = new $.Deferred();
            let options = {
                icon: 'fa',
                title: {
                    text: null,
                    color: 'text-white'
                },
                state: 'bg-danger',
                size: 'modal-lg',
                closeable: true
            };
            let url = $(selector).prop('href');
            $.when(utility.modal.open(options)).done(function () {
                $('#ModalWindowSaveButton, #ModalWindowIcon').remove();
                $('#ModalWindowBody').load(url, function (HTML) {
                    $.when($('#ModalWindowBody').html(HTML)).done(function () {
                        let img = '<img src="' + $('#ContentIcon').val() + '" style="height: 32px; width: auto;" alt="img"/>';
                        $('#ModalWindowTitle').html(img);
                        Deferred.resolve(false);
                    });
                }).css({
                    height: '70vh',
                    overflow: 'auto'
                });
                return Deferred.promise();
            });
        }
    }
};
let fnfc = {
    init: function () {
        if ($('#QuoteForm').length > 0) {
            fnfc.contact.init();
        }
        if ($('#FencingCalculatorForm').length) {
            fnfc.form.init('FencingCalculatorForm');
        }
        $('.service-tab').on('show.bs.tab', function (event) {
            location.href = $(this).attr('data-bs-target');
        });
        if ($('#Environment').val() !== 'dev') {
            $('.contact-phone').on('click', function (e) {
                utility.gtag('event', 'Phone Call', {
                    'event_category': 'Click',
                    'event_label': 'Phone Call'
                });
            });
            $('.contact-email').on('click', function (e) {
                utility.gtag('event', 'Email', {
                    'event_category': 'Click',
                    'event_label': 'Email'
                });
            });
        }
        new Swiper('.slides-2', {
            modules: [Navigation, Pagination],
            speed: 600,
            loop: true,
            autoHeight: true,
            autoplay: {
                delay: 5000,
            },
            slidesPerView: 'auto',
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 20
                },

                1200: {
                    slidesPerView: 2,
                    spaceBetween: 20
                }
            }
        });
    },
    form: {
        init: function (FormID) {
            let form = document.getElementById(FormID);
            form.addEventListener('submit', function (event) {
                event.preventDefault();
                let $GoogleRecaptcha = $('#GoogleRecaptcha');
                let grv = true;
                if ($GoogleRecaptcha.length > 0) {
                    let grv = fnfc.recaptcha.validate();
                }
                if (form.checkValidity() === false || grv === false) {
                    event.stopPropagation();
                    if (grv === false) {
                        $GoogleRecaptcha.addClass('border border-danger');
                        utility.scroll($GoogleRecaptcha);
                    }
                    utility.scroll($('.form-control:invalid, .form-check-input:invalid, .form-select:invalid').eq(0));
                } else {
                    fnfc.form.submit(FormID);
                }
                if (grv === true && $GoogleRecaptcha.length > 0) {
                    $GoogleRecaptcha.removeClass('border border-danger');
                }
                form.classList.add('was-validated');
            }, false);
        },
        submit: function (FormID) {
            let Deferred = new $.Deferred();
            let $FormID = $('#' + FormID);
            let buttonText = $('.btn-submit').html();
            $('.btn-submit').attr('disabled', 'disabled').html('<i class="fa fa-spinner fa-spin"></i>');
            $.ajax('', {
                type: 'POST',
                dataType: 'JSON',
                data: $FormID.serialize()
            }).done(function (Response) {
                $('.btn-submit').removeAttr('disabled').html('Done!');
                let showMsg = true;
                if ($FormID.hasClass('interactive') === false) {
                    let Options = {
                        icon: 'fa fa-info-circle',
                        title: {
                            text: (Response.Data.SendMail === true ? 'Request Received' : 'Error'),
                            color: 'text-white'
                        },
                        state: 'bg-danger',
                        size: 'modal-lg'
                    };
                    $.when(utility.modal.open(Options)).done(function () {
                        fnfc.form.conversion(Response);
                        $('#ModalWindowSaveButton').remove();
                        $.when($('#ModalWindowBody').html(Response.HTML)).done(function () {
                            $('#ModalWindowCancelButton').on('click', function () {
                                window.location = '/';
                            });
                            Deferred.resolve(false);
                        });
                    });
                } else {
                    let Options = {
                        icon: 'fa fa-info-circle',
                        title: {
                            text: (Response.Data.Title),
                            color: 'text-white'
                        },
                        state: 'bg-maroon',
                        size: 'modal-lg',
                        closeable: true
                    };
                    $.when(utility.modal.open(Options)).done(function () {
                        $('#ModalWindowSaveButton, #ModalWindowFooter').remove();
                        $.when($('#ModalWindowBody').html(Response.HTML)).done(function () {
                            $('.btn-submit').html(buttonText);
                            Deferred.resolve(false);
                        });
                    });
                }
            });
            return Deferred.promise();
        },
        conversion: function (Response) {
            if (Response.Data.SendMail === true) {
                let $ServiceName = $('#ServiceName');
                let $ContactLocation = $('#ContactLocation');
                let $EventLabel = ($ServiceName.length > 0 ? $ServiceName.val() : $ContactLocation.length > 0 ? $ContactLocation.val() : null);
                let $EventCategory = ($('#EventCategory').length > 0 ? $('#EventCategory').val() : null);
                $('#Conversion').val(1);
                utility.gtag('event', $EventCategory, {
                    'event_category': $EventCategory,
                    'event_label': $EventLabel
                });
                utility.gtag('set', 'user_data', {
                    "first_name": $('#FirstName').val(),
                    "last_name": $('#LastName').val(),
                    "email": $('#Email').val(),
                    "phone_number": $('#Phone').val()
                });
            }
            return false;
        }
    },
    recaptcha: {
        load: function () {
            let $Deferred = $.Deferred();
            if ($('#GoogleRecaptcha').length > 0) {
                $.getScript('https://www.google.com/recaptcha/api.js?render=explicit', function () {
                    let t = setInterval(function () {
                        if (typeof grecaptcha.render === 'function') {
                            clearInterval(t);
                            grecaptcha.render('GoogleRecaptcha', {
                                'sitekey': $('#GCKey').val()
                            });
                            $Deferred.resolve(true);
                        }
                    }, 100);
                });
            } else {
                $Deferred.resolve(true);
            }
            return $Deferred.promise();
        },
        validate: function () {
            let Response = true;
            if ($('#GoogleRecaptcha').length > 0) {
                let r = grecaptcha.getResponse()
                if (r.length === 0) {
                    Response = false;
                }
            }
            return Response;
        }
    },
    contact: {
        init: function () {
            $.when(fnfc.recaptcha.load()).done(function () {
                fnfc.form.init('QuoteForm');
            });
        }
    }
}

$(function () {
    fnfc.init();
});